export { default as stringAttribute } from './src/features/stringAttribute.js';
import { default as focusVisiblePoly } from './src/features/focus-visible-poly.js';
export { default as CachedValue } from './src/features/cachedValue.js';
import { applyDelegateFocusPolyfill } from './src/features/delegateFocusPolyfill.js';
export * from './src/features/html.js';
import { applyToggleAttributePolyFill } from './src/features/toggleAttributePolyfill.js';
export { isRTL } from './src/features/isRTL.js';
import * as ResizeListener_1 from './src/features/resizeListener.js';
export { ResizeListener_1 as ResizeListener };
import * as RTLObserver_1 from './src/features/rtlObserver.js';
export { RTLObserver_1 as RTLObserver };
import * as PredefinitionPropertyHandler_1 from './src/features/preDefinitionProperties.js';
export { PredefinitionPropertyHandler_1 as PredefinitionPropertyHandler };
export { prefixReplacer } from './src/features/prefixReplacer.js';
import * as SlotTools_1 from './src/features/evaluateSlot.js';
export { SlotTools_1 as SlotTools };
import * as BreakpointInfo_1 from './src/features/breakpointInfo.js';
export { BreakpointInfo_1 as BreakpointInfo };
/**
 * This file provides the infrastructure for a custom prefixed custom element component library.
 * It aims to ensure that the correct customised tag names are registered.
 */
const DEFAULT_PREFIX = 'skapa';
// Lookup map, custom element class => custom clement tagname
const tagNames = new Map();
const requestQueue = new Array();
/**
 * Skapa custom elements shared configuration object.
 * It's main feature is helping custom element tag name prefix management.
 */
export const config = {
    __inited: false,
    __prefixSet: false,
    __prefix: DEFAULT_PREFIX,
    get prefix() {
        this.__inited = true;
        return this.__prefix;
    },
    set prefix(val) {
        if (this.__inited && this.__prefix !== val)
            console.error('Skapa Web components tag prefix was set after init!\nMake sure to set the prefix **before** initialising any of the skapa web components');
        this.__prefix = val;
        this.__prefixSet = true;
        // Prefix is set, let process the request que:
        requestQueue.forEach(registerSkapaElement);
        requestQueue.length = 0; // reset Que
    }
};
/**
 * Registers tag name in the hosts Custom Elements Registry.
 */
function registerSkapaElement({ tag, skapaElementClass }) {
    const tagName = `${config.prefix}-${tag}`;
    if (typeof window !== 'undefined') {
        const defined = customElements.get(tagName);
        if (defined) {
            if (defined !== skapaElementClass) {
                // TODO, better way to handle this?
                console.error(`Skapa Web Component!\n"${tagName}": Different versions using the same name. Please set a unique prefix!`);
            }
        }
        else {
            customElements.define(tagName, skapaElementClass);
            tagNames.set(skapaElementClass, tagName);
        }
    }
    else {
        // TODO: No SSR Environment?
    }
    return tagName;
}
/**
 * Skapa custom element register request, the request will be processed once the prefix is set.
 *
 * @export
 * @param {string} tag
 * @param {CustomElementConstructor} skapaElementClass
 * @return {*}  {()=>string}
 */
export default function requestRegister(tag, skapaElementClass) {
    if (config.__prefixSet) {
        registerSkapaElement({ tag, skapaElementClass });
    }
    else {
        requestQueue.push({ tag, skapaElementClass });
    }
    // Return a function that provides the final registered tag name. Assuming it is called after the initalization phase
    return () => getTagFor(skapaElementClass);
}
/**
 * Helper tool to provide better debug experience with custom element registry.
 * @param customElementConstructor
 * @returns prefixed custom element tag name
 */
export function getTagFor(customElementConstructor) {
    if (!config.__prefixSet) {
        console.error('Requested custom element tag name before the custom prefix was set.\nMake sure the prefix is set in the configuration prior.');
    }
    const tagName = tagNames.get(customElementConstructor);
    if (!tagName) {
        console.error(`Requesting tag name for an unregistered custom element!\nMake sure you register the element: ${customElementConstructor.name} before using it.`);
        // probably throw error?
    }
    return tagName || '';
}
/**
 * Apply polyfills on load
 */
applyDelegateFocusPolyfill();
applyToggleAttributePolyFill();
focusVisiblePoly();
// Microtask: Auto fallback to default prefix, for environments that don't need custom prefix
setTimeout(() => {
    if (!config.__prefixSet) {
        config.prefix = DEFAULT_PREFIX;
    }
});
